import type { LocationDescriptor } from 'history';
import type { HTMLAttributes, ReactNode } from 'react';
import type { LabelData } from '../Label';

export interface HeaderProfileData {
  title?: ReactNode;
  onBackClick?: () => void;
  backLink?: LocationDescriptor;
  subtitle?: ReactNode;
  tagsPrefix?: ReactNode;
  tags?: LabelData[];
  bg?: string;
  withWhatsapp?: boolean;
}

export interface HeaderProfileProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'title'>,
    HeaderProfileData {}
